// extracted by mini-css-extract-plugin
module.exports = {"darkMode":"RichText_darkMode__YEuJI"};